const e = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_admin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "_enabled",
        type: "bool"
      }
    ],
    name: "AdminAccessSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "_requestId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "_owner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "_targetWallet",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_targetChainId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "enum ApeironBridgeBurner.NFT_TYPE",
        name: "_nftType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_tokenIDs",
        type: "uint256[]"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "gene",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "baseAge",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "evolve",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "breedCount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "breedCountMax",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "createTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "bornTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "lastBreedTime",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "relicsTokenIDs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "parents",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "children",
            type: "uint256[]"
          }
        ],
        indexed: !1,
        internalType: "struct IApeironPlanet.PlanetData[]",
        name: "_planetDatas",
        type: "tuple[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_starGeneDatas",
        type: "uint256[]"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "gene",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "iv",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "createTime",
            type: "uint256"
          }
        ],
        indexed: !1,
        internalType: "struct IApeironApostle.ApostleData[]",
        name: "_apostleDatas",
        type: "tuple[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]"
      }
    ],
    name: "BurnAsset",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "apostleContract",
    outputs: [
      {
        internalType: "contract IApeironApostle",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "blacklistContract",
    outputs: [
      {
        internalType: "contract IBlacklist",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_targetWallet",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_targetChainId",
        type: "uint256"
      },
      {
        internalType: "enum ApeironBridgeBurner.NFT_TYPE",
        name: "_nftType",
        type: "uint8"
      },
      {
        internalType: "uint256[]",
        name: "_tokenIDs",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]"
      }
    ],
    name: "burnAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "godiverseCollectionContract",
    outputs: [
      {
        internalType: "contract IApeironGodiverseCollection",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "original1155Contract",
    outputs: [
      {
        internalType: "contract IOriginal1155Collection",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "planetContract",
    outputs: [
      {
        internalType: "contract IApeironPlanet",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "requestId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "requestMap",
    outputs: [
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address"
      },
      {
        internalType: "address",
        name: "targetTargetTransferWallet",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "targetChainId",
        type: "uint256"
      },
      {
        internalType: "enum ApeironBridgeBurner.NFT_TYPE",
        name: "nftType",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "starContract",
    outputs: [
      {
        internalType: "contract IApeironStar",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "starDataContract",
    outputs: [
      {
        internalType: "contract IApeironStarData",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "starOTDataContract",
    outputs: [
      {
        internalType: "contract IApeironStarOrbitalTrackData",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_planetContractAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_starContractAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_starDataContractAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_starOTDataContractAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_apostleContractAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_godiverseCollectionContractAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_original1155ContractAddress",
        type: "address"
      }
    ],
    name: "updateContractSetting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_requestId",
        type: "uint256"
      }
    ],
    name: "updateRequestId",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=polygon-bridge-burner.json.js.map
